// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dropdown-default-icon-header_wrapper__JUQel"};